// Dyrejournal MCP proposals (Dyrejournal-koden, A; plan docs/superpowers/plans/2026-10-21-partner-mcp-dj-proposals.md).

// Where the vet lands after «Opprett» so they can check what the AI proposal created.
// `created` is the apply route's { ownerId, animalIds: [], bookingId, saleId }.
// The most specific record wins: sale, then booking, then the animal, then the owner.
// /animal and /visitor are list pages without an id parameter (app.js has no
// /animal/:id or /visitor/:id route), so animal and owner land on their list.
export function routeForCreated(type, created = {}) {
    const ids = created || {};
    const saleId = parseInt(ids.saleId, 10);
    if (saleId > 0) {
        return `/dyrejournal-sale/${saleId}`;
    }
    if (parseInt(ids.bookingId, 10) > 0) {
        return '/calendar';
    }
    const animalIds = Array.isArray(ids.animalIds) ? ids.animalIds : [];
    if (animalIds.length > 0 && parseInt(animalIds[animalIds.length - 1], 10) > 0) {
        return '/animal';
    }
    if (parseInt(ids.ownerId, 10) > 0) {
        return '/visitor';
    }
    return '/';
}

export default routeForCreated;
